module.exports = __webpack_public_path__ + "static/media/default-image.542b39ab.jpg";